<template>
<div class="main-container">
    <div class="container header column">
      <h1>Encontramos varios pacientes con tu número de documento.</h1>
    </div>
    <div class="container">
      <div class="appointment-list">
        <div
          class="appointment"
          @click="selectPatient(patient)"
          v-for="patient in patients"
          :key="patient.ficTipodocId"
        >
          <div class="appointment-details">
            <div class="appointment-date">
              <div>{{ patient.ficNombreApe }}</div>
            </div>
            <div class="appointment-date">
              <div>{{ patient.ficTipodoc }} {{ patient.ficNrodoc }}</div>
            </div>
          </div>
          <div class="btn-select">
            <span class="span-ok">{{getMessage('BTN_OKAY')}}</span>
          </div>
        </div>
      </div>
      <app-back-home :compFrom="'patientSelector'"></app-back-home>
    </div>
    <div class="container">
      <h2>{{ getMessage('MSG_NO_ESTAS_EN_LISTA_PACIENTES') }}</h2>
    </div>
    <div class="container">
      <router-link v-if="getParametrosGeneralesAmb.mostrarBtnIrRecepcionAR" :to="{ name: 'serviceSelector' }" tag="button" class="btn-secondary">{{ getMessage('BTN_IR_RECEPCION') }}</router-link>
      <router-link :to="{ name: 'patientSearch' }" tag="button" class="btn-secondary">{{ getMessage('BTN_CORREGIR_DOCUMENTO') }}</router-link>
    </div>
    <app-loader></app-loader>
  </div>
</template>
<script>

import BackHome from '@/components/AutoRecepcion/BackHome'
import { mapGetters } from 'vuex'
import Loader from '@/components/AutoRecepcion/Loader'

export default {
  components: {
    'app-loader': Loader,
    'app-back-home': BackHome
  },
  computed: {
    ...mapGetters('Patient', ['patients']),
    ...mapGetters('GeneralAR', ['getMessage']),
    ...mapGetters('InitConfig', ['getParametrosGeneralesAmb'])
  },
  props: {
    selectPatient: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './styles.scss';
</style>
